<template>
  <div class="gdpr" v-if="!hasDismissed">
    <p>By using this site you agree to our&nbsp;
      <a v-hover target="_blank" :href="/privacy-policy/">Privacy Policy.</a>
    </p>
    <a class="dismiss" v-hover v-on:click="dismissNotice()">Got It!</a>
  </div>
</template>

<script>
import { gsap } from 'gsap/all'
export default {
  name: 'SocialFooter',
  data: function () {
    return {
      hasDismissed: false
    }
  },
  methods: {
    displayNotice: function (delay) {
      gsap.set('.gdpr', {
        autoAlpha: 0,
        onComplete: function () {
          setTimeout(function () {
            gsap.fromTo('.gdpr', 1, {
              autoAlpha: 0,
              x: -200
            }, {
              autoAlpha: 1,
              x: 0
            })
          }, delay)
        }
      })
    },

    dismissNotice: function () {
      gsap.fromTo('.gdpr', 0.75, {
        autoAlpha: 1,
        x: 0
      }, {
        autoAlpha: 0,
        x: -200,
        onComplete: function () {
          localStorage.setItem('gdpr', 'dismissed')
        }
      })
    },

    isDismissed: function () {
      const gdpr = localStorage.getItem('gdpr')
      if (gdpr === 'dismissed') {
        this.hasDismissed = true
      } else {
        this.hasDismissed = false
        localStorage.setItem('gdpr', 'visible')
      }
    }
  },
  mounted: function () {
    this.isDismissed()
    this.displayNotice(8000)
    window.addEventListener('storage', (e) => {
      if (e.key === 'gdpr' && e.newValue !== 'dismissed') {
        this.hasDismissed = false
        this.displayNotice(0)
        localStorage.setItem('gdpr', 'visible')
      }
    })
  }
}
</script>

<style lang="scss">
@import "../assets/styles/breakpoints";
@import '../assets/styles/variables';

.gdpr {
  position: fixed;
  bottom: 25px;
  left: 25px;
  z-index: 12;
  display: flex;
  padding: 1rem 1.5rem;
  background: $white;
  border-left: 3px solid $gold;
  border-radius: 3px;
  box-shadow: -5px -5px 15px 0 rgba(0, 0, 0, .20);
  align-items: center;
  flex-wrap: nowrap;
  justify-content: start;

  @include breakpoint(md) {
    right: 25px;
    bottom: 25px;
    width: calc(100% - 50px);
    justify-content: space-around;
  }

  p {
    display: inline-block;
    padding: 0;
    margin: 0 1rem 0 0;
    font-weight: 200;
    line-height: 13px;
    color: $indigo;

    a {
      position: relative;
      margin: 1rem 0;
      font-weight: 200;
      white-space: nowrap;
      color: $gold;
      transition: color .3s ease-in;
      &:after {
        position: absolute;
        bottom: -1px;
        left: 0;
        width: 0;
        height: 1px;
        background: $indigo;
        content: "";
        opacity: 0;
        transition: width .3s ease-in, opacity .35s ease-in;
      }

      &:hover {
        color: $gold;
        &:after {
          width: 100%;
          opacity: 1;
        }
      }
    }
  }

  .dismiss {
    position: relative;
    padding: .2rem .5rem;
    border-radius: 5px;
    border: 1px solid $gold;
    white-space: nowrap;
    color: $gold;
    background: rgba($gold, 0.1);
    span {
      display: inline-block;
      letter-spacing: .5px;
    }

    &:hover {
      &:after {
        width: 100%;
        opacity: 1;
      }
    }
  }
}
</style>
